import type React from 'react';
import type { FC } from 'react';

import { useTranslation } from '@crehana/i18n';
import { useRouter } from 'next/router';

import useAdminDashboard from '@/views/AdminDashboard/hooks/useAdminDashboard';

const ViewMoreResults: FC<
  React.PropsWithChildren<{
    isDark?: boolean;
    organizationSlug: string;
    searchKey: string;
  }>
> = ({ isDark, organizationSlug, searchKey }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { isCorporation } = useAdminDashboard();

  return (
    <div
      className={`w-full py-20 px-32 border-t border-solid flex justify-center ${
        isDark ? 'border-base-lighter-dark-mode' : 'border-gray-light'
      }`}
    >
      <button
        type="button"
        className={`font-link-2 ${
          isDark ? 'text-secondary-main' : 'text-primary-main'
        }`}
        onClick={() => {
          router.push({
            pathname: `/org/${organizationSlug}/${
              isCorporation ? 'panel/corp' : 'panel'
            }/busqueda/`,
            query: { q: searchKey },
          });
        }}
      >
        {t('SEARCH_ALL_RESULTS')}
      </button>
    </div>
  );
};

export default ViewMoreResults;
